import React, { useState, useEffect } from 'react';
import { Row, Col } from 'antd';

import ApplicationService from './../../../services/ApplicationService';
import ApplicationDetails from './ApplicationDetails';
import CustomerInfo from './CustomerInfo';
import Conditions from "./Conditions";
import Products from "./Products";
import ActionsBar from "./ActionsBar";
import { getDayDiff } from "../../../helpers/parsers";
import { STATES } from "../../../helpers/constants";
import ApplicationStateBar from './ApplicationStateBar';

const Application = ({ match }) => {
    const uuId = match.params.uuId;
    const [loading, setLoading] = useState(true);
    const [application, setApplication] = useState();
    const [appState, setAppState] = useState(null);

    useEffect(() => {
        ApplicationService.getApplication(uuId).then((application) => {
            setApplication(application);
            setAppState(application.state);
            setLoading(false);
        })
    }, [uuId]);

    if (loading) return <div>loading</div>;

    const appStateChange = (state) => {
        setAppState(state);
    }

    const setPrintedDocuments = (documentsPrinted) => {
        setApplication({
            ...application,
            documentsPrinted
        })
    }

    const setAttachments = (attachments) => {
        setApplication({
            ...application,
            attachments
        })
    }

    const updateApplication = (application) => {
        setApplication(application)
        setAppState(application.state)
    }

    return (
        <div>
            <div className='bg-white px-2'>
                <ActionsBar
                    appStateChange={appStateChange}
                    application={application}
                    state={appState}
                    setPrintedDocuments={setPrintedDocuments}
                    setAttachments={setAttachments}
                />
            </div>
            <div className='px-2'>
                <ApplicationStateBar
                    application={application}
                    appState={appState}
                    setPrintedDocuments={setPrintedDocuments}
                    appChange={updateApplication}
                />
                <ApplicationDetails
                    state={appState}
                    application={application}
                />
                <CustomerInfo
                    uuId={uuId}
                    appState={appState}
                    setApplication={setApplication}
                    customer={application.customer}
                />
                <div className='mt-1'>
                    <Row className='bg-white'>
                        <Col span={14}>
                            <Products application={application} />
                        </Col>
                        {(application.state !== STATES.finished || getDayDiff(application.updated) < 2) && (
                            <Col span={10}>
                                <Conditions application={application} />
                            </Col>
                        )}
                    </Row>
                </div>

            </div>
        </div>
    )
};


export default Application;